import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Legacy /account/user/waitlist redirected to /appointments?tab=waitlist.
 * Mirror that here. apps/app /account/user/appointments needs the
 * "waitlist" tab; for V1.0+ we route there as the canonical destination
 * — the appointments page will pick up an unknown ?tab and fall back to
 * the default ("upcoming") gracefully.
 */
export const Route = createFileRoute("/_authenticated/account/user/waitlist")({
  beforeLoad: () => {
    throw redirect({ to: "/account/user/appointments", search: { tab: "waitlist" } });
  },
});
